import { createSlice } from "@reduxjs/toolkit";
import {
  getEnergyBreakdown,
  getEnergyPrediction,
  getHubDetailEnergyConsumption,
  getHubDetailKPIs,
  getHubKPIs,
  getLineChart,
} from "../APIs/hubAPI";

const initialState = {
  loading: false,
  error: {},
  status: "idle",
  kpi: {
    totalEnergyProduced: 0,
    totalEnergyStoredInSolar: 0,
    totalEnergyStoredInGrid: 0,
    totalEnergyConsumedBySolar: 0,
    totalEnergyConsumedByGrid: 0,
  },

  hubEnergyBreakdown: {
    result: [],
    totalRecords: 0,
  },

  hubDetailsKpi: {
    totalEnergyProduced: 0,
    totalEnergyStoredInSolar: 0,
    totalEnergyStoredInGrid: 0,
  },

  energyPrediction: {
    battery: {},
    trip: {},
    session: {},
  },

  hubDetailsEnergyConsumption: [],

  lineChart: [],

  currentHub: {},

  currentCharger: {},

  historyDrawer: false,

  threeDotsPopoverId: 0,

  detailsToastMessage: {
    visible: false,
    data: {},
  },
};

export const hubsSlice = createSlice({
  name: "hubs",
  initialState,
  reducers: {
    updateHub: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
  },
  extraReducers(builder) {
    // get hub kpis
    builder.addCase(getHubKPIs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHubKPIs.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.kpi = action.payload.kpi;
    });
    builder.addCase(getHubKPIs.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get hubs for energy breakdown fold
    builder.addCase(getEnergyBreakdown.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEnergyBreakdown.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.hubEnergyBreakdown = action.payload;
    });
    builder.addCase(getEnergyBreakdown.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get hub detail kpis
    builder.addCase(getHubDetailKPIs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHubDetailKPIs.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.hubDetailsKpi = action.payload.kpi;
    });
    builder.addCase(getHubDetailKPIs.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get hub detail kpis
    builder.addCase(getEnergyPrediction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEnergyPrediction.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.energyPrediction = action.payload.result;
    });
    builder.addCase(getEnergyPrediction.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get hub detail energy consumption
    builder.addCase(getHubDetailEnergyConsumption.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      getHubDetailEnergyConsumption.fulfilled,
      (state, action) => {
        state.loading = false;
        state.status = "fulfilled";
        state.hubDetailsEnergyConsumption = action.payload.result;
      },
    );

    builder.addCase(getHubDetailEnergyConsumption.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get line chart data
    builder.addCase(getLineChart.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getLineChart.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.lineChart = action.payload.response;
    });

    builder.addCase(getLineChart.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });
  },
});

export const { updateHub } = hubsSlice.actions;

export default hubsSlice.reducer;
